module.exports = __webpack_public_path__ + "media/box_anim_battle.cc999ac1.mp3";